/**
 * CheckInModalRoute (BON-204 R2) — the element for the nested
 * `workshops/:workshopId/checkin` route. Renders the {@link CheckInModal} as an
 * overlay over the workshop detail page, reading the workshop + eligibility from
 * the parent route's outlet context. A deep-link to `/checkin` on a read-only /
 * non-active workshop redirects back to the detail page. Done/×/Escape/scrim
 * navigate back to the detail route too.
 */
import { Navigate, useNavigate } from 'react-router-dom';

import { CheckInModal } from './CheckInModal';
import { useCheckInRouteCtx } from './workshopDetailContext';

export default function CheckInModalRoute() {
  const { workshop, canCheckIn, closeHref } = useCheckInRouteCtx();
  const navigate = useNavigate();

  if (!canCheckIn) {
    return <Navigate to={closeHref} replace />;
  }

  return <CheckInModal workshop={workshop} onClose={() => navigate(closeHref)} />;
}
